import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AICreationWorkspace } from "@core/components/ai/AICreationWorkspace";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";

/**
 * Workspace de création pour les sondages de dates
 * Utilise AICreationWorkspace avec ProductSidebar pour avoir le menu de gauche
 */
export default function DatePollCreationWorkspace() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // S'assurer que le type "date" est dans les search params
    if (searchParams.get("type") !== "date") {
      searchParams.set("type", "date");
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  console.log(
    "🔧 DatePollCreationWorkspace MOUNTED - using AICreationWorkspace with sidebar",
  );

  return (
    <div className="flex flex-col h-screen-safe bg-background dark:bg-[#0a0a0a] overflow-hidden">
      {/* Contenu principal avec sidebar - AICreationWorkspace gère son propre header */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <ProductSidebar productType="date" />

        {/* Contenu principal - AICreationWorkspace sans sa propre sidebar */}
        <AICreationWorkspace pollTypeFromUrl="date" hideSidebar={true} />
      </div>
    </div>
  );
}
